import React from 'react'
import './styles/ShareOptionsModal.css'

const ShareOptionsModalOption = ({ icon, title, description, onClick }) => {
  return (
    <div
      className="share-options-modal-option d-flex align-items-center justify-content-between p-2 border rounded mt-3 gap-3 px-3"
      style={{ height: '100px', cursor: 'pointer' }}
      onClick={onClick}
    >
      <div className="d-flex flex-column justify-content-center w-auto">
        <div className="d-flex justify-content-start align-items-center">
          <img src={icon} alt={title} height="16" width="16" className="d-flex" />
          <h6 className="d-flex ms-2 mb-0 fw-bold">{title}</h6>
        </div>
        <div className="d-flex small mt-1 text-start">{description}</div>
      </div>
      <div className="d-flex justify-content-end">
        <img alt="tick" src="/assets/icons/left.png" height={32} width={32} style={{ transform: 'scaleX(-1)' }} />
      </div>
    </div>
  )
}

export default ShareOptionsModalOption
